import obfuscation from 'app/services/businessFunctions/calculation/insurant/obfuscation';
import autocomplete from 'app/services/businessFunctions/calculation/insurant/autocomplete';
import consents from 'app/services/businessFunctions/calculation/insurant/consents';

export const insurant = {
  ...obfuscation,
  ...autocomplete,
  ...consents,
};
